import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  isInternalUser: boolean;
  constructor(private userService: UserService,
    private authService: AuthService,
    private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
     // TEMP: auth disabled for testing
    return true;
    // if (!this.authService.isAuthenticated()) {
    //   this.userService.UnAuthReq.next(true);
    //   this.router.navigate(['/unauthorized']);
    //   return false;
    // } else {
    //   return true;
    // }
  }
}


